import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { config } from '../config';
import { useI18n } from '../i18n';
import { useApp } from '../app/AppContext';

export function Layout({ children }: { children: ReactNode }) {
  const { t, locale, setLocale } = useI18n();
  const { session } = useApp();

  return (
    <div className="app-shell">
      <a className="skip-link" href="#main">
        跳到主要內容
      </a>
      <header className="app-header">
        <Link className="app-header__brand" to="/">
          <span aria-hidden="true">✊✋✌️</span>
          <span>{t('app.title')}</span>
          <small>{t('app.subtitle')}</small>
        </Link>
        <div className="app-header__right">
          {session ? <span title={session.subjectId}>👤 {session.displayName || t('guest.you')}</span> : null}
          <button
            type="button"
            className="btn btn--ghost btn--sm"
            onClick={() => setLocale(locale === 'zh-TW' ? 'en' : 'zh-TW')}
          >
            {t('lang.switch')}
          </button>
        </div>
      </header>

      <main id="main" className="page">
        {children}
      </main>

      <footer className="app-footer">
        <span>{t('app.tagline')}</span>
        <span>build {config.buildVersion}</span>
      </footer>
    </div>
  );
}
